import { l as lodash } from './lodash-5c867657.js';

const getDataModel = (doc) => {
    const typeMap = { generic: 'file', file: 'file', enrichedfile: 'file', enrichedpage: 'page', page: 'page' };
    let type = lodash.get(doc, 'type') || 'file';
    return typeMap[lodash.toLower(type)] || type;
};
const getTitleField = (fields, config = {}) => {
    var _a, _b;
    if (lodash.has(fields, (_a = config === null || config === void 0 ? void 0 : config.displayFields) === null || _a === void 0 ? void 0 : _a.title)) {
        return (_b = config === null || config === void 0 ? void 0 : config.displayFields) === null || _b === void 0 ? void 0 : _b.title;
    }
    else if (lodash.has(fields, 'document.title')) {
        return 'document.title';
    }
    else {
        return 'title';
    }
};
const getCreatedField = (fields) => lodash.has(fields, 'document.sourceCreateTimestamp') ? 'document.sourceCreateTimestamp' : 'indexed';
const getModifiedField = (fields) => lodash.has(fields, 'document.modified') ? 'document.modified' : 'modified';
const getURLField = (fields, config = {}) => {
    var _a, _b;
    if (lodash.has(fields, (_a = config === null || config === void 0 ? void 0 : config.displayFields) === null || _a === void 0 ? void 0 : _a.url)) {
        return (_b = config === null || config === void 0 ? void 0 : config.displayFields) === null || _b === void 0 ? void 0 : _b.url;
    }
    else if (lodash.has(fields, 'document.url')) {
        return 'document.url';
    }
    else {
        return 'url';
    }
};
const getImageField = (fields, config = {}) => {
    var _a, _b;
    if (lodash.has(fields, (_a = config === null || config === void 0 ? void 0 : config.displayFields) === null || _a === void 0 ? void 0 : _a.image)) {
        return (_b = config === null || config === void 0 ? void 0 : config.displayFields) === null || _b === void 0 ? void 0 : _b.image;
    }
    else if (lodash.has(fields, 'document.thumbnailImage')) {
        return 'document.thumbnailImage';
    }
    else {
        return 'image';
    }
};
const getBodyField = (fields, config = {}) => {
    var _a, _b;
    if (lodash.has(fields, (_a = config === null || config === void 0 ? void 0 : config.displayFields) === null || _a === void 0 ? void 0 : _a.description)) {
        return (_b = config === null || config === void 0 ? void 0 : config.displayFields) === null || _b === void 0 ? void 0 : _b.description;
    }
    else if (lodash.has(fields, 'document.description')) {
        return 'document.description';
    }
    else if (lodash.has(fields, 'document.body')) {
        return 'document.body';
    }
    else {
        return 'body';
    }
};
const getLanguageField = (fields) => lodash.has(fields, 'document.languageCode') ? 'document.languageCode' : 'languageCode';

const resultUtils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getDataModel: getDataModel,
    getTitleField: getTitleField,
    getCreatedField: getCreatedField,
    getModifiedField: getModifiedField,
    getURLField: getURLField,
    getImageField: getImageField,
    getBodyField: getBodyField,
    getLanguageField: getLanguageField
});

export { getBodyField as a, getLanguageField as b, getTitleField as c, getModifiedField as d, getURLField as e, getImageField as f, getDataModel as g, resultUtils as r };
